export default "__VITE_ASSET__4cb52922__"